import { Card } from "reactstrap";
import { ListProducts } from "../../TaxAnalysis/List/Tables";
import { QUEIMA_E_RISCO_MOCK } from "../../../constants/ArquivaMix/mocks/queimaERisco.mock";
import { WrapperArquivaMix } from "../wrapperArquivaMix";
import { QueimaDeCaixaContent } from "./queimaDeCaixaContent";
import { RiscoAssumidoContent } from "./riscoAssumidoContent";
import { useParams } from "react-router-dom";

export const ArquivaMixListAnaliseFiscal = () => {
  const { type } = useParams();

  return (
    <WrapperArquivaMix
      overlayContent={
        type === "queima-caixa" ? (
          <QueimaDeCaixaContent />
        ) : (
          <RiscoAssumidoContent />
        )
      }
      buttonText={
        type === "queima-caixa"
          ? "✨ Ativar acesso premium ✨"
          : "✨ Ativar acesso premium e ver onde sua margem está vulnerável ✨"
      }
    >
      <Card className="m-0">
        <ListProducts data={QUEIMA_E_RISCO_MOCK} />
      </Card>
    </WrapperArquivaMix>
  );
};
